import { render, staticRenderFns } from "./PoolRivalChalkConfig.vue?vue&type=template&id=73c7e18e"
import script from "./PoolRivalChalkConfig.vue?vue&type=script&lang=js"
export * from "./PoolRivalChalkConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports